import { sendBeacon } from "utils/send-beacon"

/**
 * Tracks plugin-related events using the Beacon API for non-blocking event submission.
 * This function is used to track events like plugin installation and removal.
 *
 * The Beacon API is used for performance optimization as it allows the browser to
 * schedule the request optimally and doesn't require waiting for a response.
 *
 * @param {Object} params - The event parameters
 * @param {string} params.pluginId - The id of the plugin
 * @param {string} params.action - The type of action being performed ('Added', 'Removed')
 */
export function sendPluginEvent({ pluginId, action }) {
  const data = JSON.stringify({ event_action: action })

  sendBeacon(`/plugins/${pluginId}/plugin_events`, data)
}
